import throwErrorIfTesting from "@insite/client-framework/Common/ThrowErrorIfTesting";
import {
    ApiHandler,
    createHandlerChainRunner,
    HasOnSuccess,
    markSkipOnCompleteIfOnSuccessIsSet,
} from "@insite/client-framework/HandlerCreator";
import { getCustomerDetail, LoadCustomerDetailParameter } from "@TKCCP/Services/tkccpCustomerRegistrationService";
import { LoadCustomerDetailModel } from "@TKCCP/Types/ApiModels";

type CustomerDetailParameter = {
    onError?: (error: string) => void;
} & LoadCustomerDetailParameter &
    HasOnSuccess<LoadCustomerDetailModel>;

type HandlerType = ApiHandler<CustomerDetailParameter, LoadCustomerDetailModel>;

export const PopulateApiParameter: HandlerType = props => {
    throwErrorIfTesting();
    props.apiParameter = props.parameter;
};

export const SendDataToApi: HandlerType = async props => {
    props.apiResult = await getCustomerDetail(props.apiParameter);
};

export const ExecuteOnSuccessCallback: HandlerType = props => {
    markSkipOnCompleteIfOnSuccessIsSet(props);

    props.parameter.onSuccess?.(props.apiResult);
};

export const chain = [PopulateApiParameter, SendDataToApi, ExecuteOnSuccessCallback];

const loadCustomerDetails = createHandlerChainRunner(chain, "LoadCustomerDetails");
export default loadCustomerDetails;
